import { queryOptions } from '@tanstack/react-query';

import { type InfrastructureQueryParams, infrastructureService } from '~api/services';

/**
 * Generate query options for fetching infrastructure sites based on blast name and optional buffer distance
 * @param params - Query parameters including blast name and optional buffer distance
 * @returns Query options for fetching infrastructure data
 */
function infrastructureQueryOptions(params: InfrastructureQueryParams) {
  return queryOptions({
    queryKey: ['infrastructure', params],
    queryFn: () => infrastructureService.getInfrastructure(params),
  });
}

export { infrastructureQueryOptions };
